import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../assets/images/anvika-logo.png";

import {
  FaPhone, FaEnvelope, FaMapMarkerAlt,
  FaFacebookF, FaWhatsapp, FaInstagram, FaLinkedinIn,
  FaArrowRight,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "Home", to: "/" },
    { label: "Products", to: "/products" },
    { label: "Services", to: "/services" },
    { label: "Product Categories", to: "/material" },
    { label: "About Us", to: "/about" },
    { label: "Contact", to: "/contact" },
  ];

  const services = [
    "Stretch Film & Bubble Roll",
    "PP & PET Strap Supply",
    "Corrugated Box & Pallet",
    "Lashing & Cargo Belts",
    "Foam Sheet & Silica Gel",
    "Bulk Order Support",
  ];

  return (
    <footer className="footer">
      <Container>
        <Row className="footer-row">
          
          {/* Column 1 - Brand */}
          <Col lg={4} md={6} className="footer-col">
            <img src={logo} alt="Anvika Logo" className="footer-logo" />
            <p className="footer-description">
              Trusted manufacturer & supplier of industrial packaging materials in Pune.
              Stretch films, foam sheets, BOPP tapes, strapping, lashing belts, 
              corrugated boxes, pallets & more — serving industries across India.
            </p>
            <div className="footer-social">
              {/* <a href="https://wa.me/919834430943" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <FaWhatsapp />
              </a> */}
              {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a> */}
            </div>
          </Col>

          {/* Column 2 - Quick Links */}
          <Col lg={2} md={6} className="footer-col">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to}>
                    <FaArrowRight className="link-icon" /> {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Column 3 - Services */}
          <Col lg={3} md={6} className="footer-col">
            <h4 className="footer-title">Our Services</h4>
            <ul className="footer-links">
              {services.map((service, idx) => (
                <li key={idx}>
                  <span>
                    <FaArrowRight className="link-icon" /> {service}
                  </span>
                </li>
              ))}
            </ul>
          </Col>

          {/* Column 4 - Contact */}
          <Col lg={3} md={6} className="footer-col">
            <h4 className="footer-title">Contact Info</h4>
            <ul className="footer-contact">
              <li>
                <FaMapMarkerAlt className="contact-icon" />
                <div className="contact-details">
                  <strong>Work Address</strong>
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=Satav+Industrial+Estate+Chakan+Pune" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Gat No. 374, Satav Industrial Estate, Chakan Talegaon Rd, Kharabwadi, Chakan, Pune – 410501
                  </a>
                </div>
              </li>
               <li>
                <FaMapMarkerAlt className="contact-icon" />
                <div className="contact-details">
                  <strong>Work Address</strong>
                  <a 
                    href="https://maps.app.goo.gl/qMviM8LyEPjdBtnU8" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Shindewadi, bhor mahad road, shindewadi - 412801
                  </a>
                </div>
              </li>
              <li>
                <FaMapMarkerAlt className="contact-icon" />
                <div className="contact-details">
                  <strong>Office Address</strong>
                  <span>Stealla Tower, Moshi Alandi Rd, Moshi, Pune – 412105</span>
                </div>
              </li>
              <li>
                <FaPhone className="contact-icon" />
                <div className="contact-details">
                  <strong>Mr. Vikrant Vele</strong>
                  <a href="tel:+919834430943">+91 9834430943</a>
                </div>
              </li>
              <li>
                <FaEnvelope className="contact-icon" />
                <div className="contact-details">
                  <strong>Email</strong>
                  <a href="mailto:anvikaind.1supplier@gmail.com">anvikaind.1supplier@gmail.com</a>
                  <a href="mailto:sales.anvikaind@gmail.com">sales.anvikaind@gmail.com</a>
                </div>
              </li>
            </ul>
          </Col>

        </Row>
      </Container>

      {/* Copyright Bar */}
      <div className="footer-bottom">
        <Container>
          <div className="footer-copyright">
            <p>© {currentYear} <strong>Anvika Industrial Supplier</strong>. All rights reserved.</p>
            <p>Manufacturer & Supplier of Industrial Packaging Materials — Pune, India</p>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;